import { render } from "./HelloWorld.vue?vue&type=template&id=50076948&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=50076948&scoped=true&lang=css"

import exportComponent from "/Users/franky/Documents/fugenbild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50076948"]])

export default __exports__